module.exports = __webpack_public_path__ + "static/media/oops_img_globe.36c6875e.svg";